import script from "/app/pages/Home/invoice_information_edit.vue?type=script";
import "/app/pages/Home/invoice_information_edit.vue?type=style";
import { render } from "/app/pages/Home/invoice_information_edit.vue?type=template";
script.render = render;
export default script;
